<div class="table-wrapper">
  <ngx-datatable #table style="width: 100%" class="material" [rows]="flattenedRows" [columns]="visibleColumns"
    [columnMode]="'force'" [headerHeight]="40" [footerHeight]="40" [rowHeight]="40" (activate)="onCellActivate($event)"
    [externalSorting]="true" (sort)="onSort($event)">
    <ngx-datatable-footer>
      <ng-template ngx-datatable-footer-template>
        <div class="footer-total-row">
          <div *ngFor="let col of visibleColumns" class="footer-cell">
            <strong>
              {{
              col.prop === 'name' && col.levelIndex===0
              ? 'Total'
              : (col.prop && col.prop !== 'name' && grandTotalRow?.[col.prop] !== undefined
              ? col.type=='number' ? ((grandTotalRow[col.prop])| number : "1.0-0"): (grandTotalRow[col.prop]) +'%'
              : '')
              }}
            </strong>
          </div>
        </div>
      </ng-template>
    </ngx-datatable-footer>
  </ngx-datatable>

  <div class="table-spinner-overlay" *ngIf="isLoading">
    <mat-spinner diameter="40"></mat-spinner>
  </div>
  <ng-template #percentageCell let-value="value">
    {{ value | number : "1.1-1" }}%
  </ng-template>
  <ng-template #numberCell let-value="value">
    {{ value | number : "1.0-0" }}
  </ng-template>
  <ng-template #treeCell let-row="row" let-rowIndex="rowIndex" let-columnIndex="columnIndex" let-value="value"
    let-column="column">
    <div *ngIf="row.isTotal && row.level === column.levelIndex + 1" style="font-weight: bold; color: #444">
      {{ row.name }}
    </div>

    <div *ngIf="!row.isTotal && row.level === column.levelIndex + 1"
      style="display: flex; align-items: center; justify-content: space-between"
      [ngClass]="{ 'highlight-cell': highlightedCells.includes(rowIndex + '-' + column.prop) }">
      <div style="display: flex; align-items: center; gap: 4px; cursor: pointer">
        <mat-icon (click)="toggleExpand(row); $event.stopPropagation()" *ngIf="row.children?.length" style="
            font-size: 18px;
            line-height: 1;
            display: flex;
            align-items: center;
          ">
          {{ row.expanded ? "remove_circle_outline" : "add_circle_outline" }}
        </mat-icon>

        <div style="
            font-weight: bold;
            color: #444;
            display: flex;
            align-items: center;
          ">
          {{ row.name }}
        </div>
      </div>

      <mat-icon (click)="$event.stopPropagation()" *ngIf="column.levelIndex === 2"
        [matMenuTriggerFor]="menu">more_vert</mat-icon>
    </div>
    <mat-menu #menu="matMenu">
      <button mat-menu-item (click)="navigateTo('opportunity-simulator', row)">
        Opportunity Simulator
      </button>
      <button mat-menu-item (click)="navigateTo('/cspec-bridge', row)">
        CSpec Bridge
      </button>
    </mat-menu>
  </ng-template>
</div>